import { styled, Typography } from '@mui/material';

import { Button } from 'components';

export const FormContainer = styled('div')`
  width: 671px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 32px 24px;
  position: relative;
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};

  @media (max-width: 1023px) {
    width: 100%;
    padding: 16px 8px;
    margin-bottom: 110px;
    &.editMode {
      margin-bottom: 0px;
    }
  }
`;

export const FormFooter = styled('div')`
  display: flex;
`;

export const FormTitle = styled(Typography)`
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 16px;
`;

export const FormButtonsWrapper = styled('div')`
  display: flex;
  gap: 12px;
  margin-left: auto;
`;

export const CancelBtn = styled(Button)`
  text-transform: none;
  border-radius: 8px;
  padding: 10px 32px;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.primary.p080};
  border-color: ${({ theme }) => theme.palette.primary.light};
  background: ${({ theme }) => theme.palette.white.main};

  &:hover {
    background: ${({ theme }) => theme.palette.white.p100};
    border-color: ${({ theme }) => theme.palette.primary.p030};
  }
`;

export const CreateBtn = styled(Button)`
  text-transform: none;
  border-radius: 8px;
  padding: 10px 32px;
  font-weight: 600;
  font-size: 16px;
  background: ${({ theme }) => theme.palette.info.main};
  color: ${({ theme }) => theme.palette.white.main};

  &:hover {
    background: ${({ theme }) => theme.palette.info.dark};
  }

  &:disabled {
    background: ${({ theme }) => theme.palette.info.p030};
    color: ${({ theme }) => theme.palette.white.main};
  }
`;
